<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        成本优化解决方案
      </a-typography-title>
      <a-typography-paragraph>
        {{
          '通过成本可视化实现深入成本洞察，并提供精细化的算力治理，' +
          '在维持业务稳定性的前提下，帮助企业降低IT成本高达50%。'
        }}
      </a-typography-paragraph>
      <!-- <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="$RQ.GoGSS()">
          免费试用
        </a-button>
      </a-space> -->
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_banner'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planCost/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 150px 0 80px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

div.ant-typography {
  max-width: 450px;
  margin: 20px 0 0;
  .font(justify, @text+@line, @color_white, @text);
}

.ant-space {
  margin: 20px 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>